"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const isTopLevelObject_1 = require("./utils/isTopLevelObject");
const AccordionGroupTemplate_1 = __importDefault(require("./AccordionGroupTemplate"));
const DefaultObjectFieldTemplate_1 = __importDefault(require("./DefaultObjectFieldTemplate"));
const ObjectFieldTemplate = (props) => {
    const { idSchema, properties, schema } = props;
    const shouldRenderAccordion = (0, isTopLevelObject_1.isTopLevelObject)(idSchema.$id, schema) && properties.length;
    if (shouldRenderAccordion) {
        return react_1.default.createElement(AccordionGroupTemplate_1.default, { ...props });
    }
    return react_1.default.createElement(DefaultObjectFieldTemplate_1.default, { ...props });
};
exports.default = ObjectFieldTemplate;
